import { render } from "./ListQcConfigurations.vue?vue&type=template&id=f7184af0"
import script from "./ListQcConfigurations.vue?vue&type=script&lang=js"
export * from "./ListQcConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__